import { Component, OnInit, Input } from '@angular/core';
import { TitleConfigurations, TitleLineConfigurations } from "../title/title.configurations";
import { SurveyConfigurations } from "./survay.models";
import { Image } from '../services/kla.data.models';
import { CommonModule } from '@angular/common';
import { SimpleImageComponent } from '../simple-image/simple-image.component';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'kla-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss'],
  standalone: true,
  imports: [ CommonModule, SimpleImageComponent, ButtonComponent ]
})
export class SurveyComponent implements OnInit {

  @Input()
  public titleConfig: TitleConfigurations;

  @Input()
  public lineConfig: TitleLineConfigurations;

  @Input()
  public surveyConfig: SurveyConfigurations;

  ngOnInit() {
    if (this.surveyConfig.imageObject) {
      this.surveyConfig.imageObject.width = 900;
    }
    if(this.surveyConfig?.imageWidth) {
      this.titleConfig.imageWidth = this.surveyConfig.imageWidth;
    }
    if(this.surveyConfig?.imageHeight) {
      this.titleConfig.imageHeight = this.surveyConfig.imageHeight;
    }
  }

  openLink() {
    window.open(this.surveyConfig.link, 'blank');
  }
}
